import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "data-ingestion-history-table" };
const _hoisted_2 = { class: "data-ingestion-history-table__title" };
const _hoisted_3 = ["src"];
const _hoisted_4 = ["innerHTML"];
import InfoCard from '@/components/_atoms/InfoCard';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DataIngestionHistoryTable',
    props: {
        data: {},
        columns: {},
        status: {}
    },
    setup(__props) {
        const props = __props;
        const getWidth = (columnKey) => {
            const width = {
                table: 35,
                time: 30,
                status: 120,
                filename: 80,
            };
            const hasWidth = Object.keys(width).includes(columnKey);
            return hasWidth ? width[columnKey] : 100;
        };
        return (_ctx, _cache) => {
            const _component_el_table_column = _resolveComponent("el-table-column");
            const _component_el_table = _resolveComponent("el-table");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("strong", _hoisted_2, _toDisplayString(_ctx.$t('data-ingestion-history.table.info')), 1),
                _createVNode(_component_el_table, {
                    data: props.data,
                    style: { "width": "100%" },
                    "empty-text": " "
                }, {
                    empty: _withCtx(() => [
                        _createVNode(_unref(InfoCard), {
                            "custom-title": _ctx.$t('data-ingestion-history.table.custom-title'),
                            "custom-message": _ctx.$t('data-ingestion-history.table.custom-message')
                        }, null, 8, ["custom-title", "custom-message"])
                    ]),
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.columns, (column, index) => {
                            return (_openBlock(), _createBlock(_component_el_table_column, {
                                key: index,
                                prop: column.key,
                                label: column.name,
                                "min-width": getWidth(column.key)
                            }, {
                                default: _withCtx((scope) => [
                                    (column.key === 'table')
                                        ? (_openBlock(), _createElementBlock("strong", {
                                            key: 0,
                                            class: _normalizeClass(`data-ingestion-history-table__status--${scope.row.status}`)
                                        }, [
                                            _createElementVNode("img", {
                                                src: require(`@/assets/svgs/icons/${scope.row.status}.svg`)
                                            }, null, 8, _hoisted_3),
                                            _createTextVNode(" " + _toDisplayString(scope.row.table), 1)
                                        ], 2))
                                        : _createCommentVNode("", true),
                                    (column.key === 'message')
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 1,
                                            innerHTML: scope.row.message
                                        }, null, 8, _hoisted_4))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 2
                            }, 1032, ["prop", "label", "min-width"]));
                        }), 128))
                    ]),
                    _: 1
                }, 8, ["data"])
            ]));
        };
    }
});
